import React from 'react';
import UserNavigation from './UserNavigation';

export default class UserNavigationBackWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            backUrl: null
        };
    }

    componentWillMount() {
        this.setState({
            backUrl: UserNavigation.getBack(this.props.userUid)
        });
    }
    render() {
        return this.state.backUrl ? 
            <a rel="nofollow" href={this.state.backUrl}>{this.props.backLang ? this.props.backLang : 'Back'}</a>
         : null;
    }
}
